import React, { useEffect, useState } from 'react'
import useHttp from '../../../hook/use-http'
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates'
import "./Driveanalysis_Kratos.css"
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../redux/userSlice";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { decodeToken } from "react-jwt";


const TOP_KPIS_FIRST_PAGE = {
  vehiclecount: 0,
  total_km: 0,
  median_range: 0,
  mean_whr_km: 0,
  Median_NetkWh: 0,
  median_dis_duration: 0
};

export default function Topkpis_Kratos({ gloablfilter }) {
  const [topdata, setTopData] = useState(TOP_KPIS_FIRST_PAGE);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [totalvehicle, setTotalVehicle] = useState(0);
  const [totalvehicledata, setTotalVehicleData] = useState([]);
  const [isCESL_lastDate, setCESL_lastDate] = useState(false)


  useEffect(() => {
    const tokenNew = JSON.parse(sessionStorage.user);
    let decodedToken = decodeToken(tokenNew.token);
    const usernameNew = decodedToken.access_type;
    // const usernameNew = "1,2,3";
    // const usernameNew = "1";
    var split_str = usernameNew.split(",");
    if (split_str.indexOf("14") !== -1) {
      setCESL_lastDate(true)
    }
  }, [isCESL_lastDate]);

  function median(numbers) {
    const sorted = Array.from(numbers).sort((a, b) => a - b);
    const middle = Math.floor(sorted.length / 2);

    if (sorted.length % 2 === 0) {
      if ((((sorted[middle - 1] + sorted[middle]) / 2).toFixed(2)) !== "NaN")
        return ((sorted[middle - 1] + sorted[middle]) / 2).toFixed(2);
      else
        return 0
    }
    let count = 0
    for (let i = 0; i < sorted.length; i++)
      if (sorted[i] === null)
        count = count + 1
    if (sorted.length === count)
      return 0
    if ((sorted[middle].toFixed(2)) !== "NaN")
      return sorted[middle].toFixed(2)
    else
      return 0
  }
  const appyDataVehicle = (data) => {
    const res_result = data[0];
    if (res_result.length !== 0)
      setTotalVehicle(res_result.totalvehicle.value)
    else
      setTotalVehicle(0)

  }
  const appyData = (data) => {
    const res_result = data;
    let total_vehicle_count = 0
    let distanceInKM = 0
    let responce = {};
    let adddist = 0
    let rangeMedian = []
    let mean_whr_km = []
    let median_NetkWh = []
    let idel_time_per = []
    let median_dis_duration = []
    if (res_result.length != 0) {
      let temp_result_new = res_result;
      temp_result_new.map(temp_result => {
        total_vehicle_count += temp_result.Total_vehicles.value
        distanceInKM += temp_result.distanceInKM.value
        rangeMedian.push(temp_result.median_Range.values["50.0"] || 0)
        median_NetkWh.push(temp_result.Median_NetkWh.values["50.0"] || 0)
        mean_whr_km.push(temp_result.median_whPerKM.values["50.0"] || 0)
        median_dis_duration.push(temp_result.Median_dischargeSoc.values["50.0"] || 0)
      }

      )
      responce = {
        vehiclecount: total_vehicle_count,
        total_km: distanceInKM.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        median_range: median(rangeMedian),
        Median_NetkWh: median(median_NetkWh),
        mean_whr_km: median(mean_whr_km),
        median_dis_duration: median(median_dis_duration)
      }
      setTopData((prestate) => responce);
    }
    else {
      setTopData((prestate) => TOP_KPIS_FIRST_PAGE);
    }
  }

  const appyTotalData = (data) =>{
    setTotalVehicleData(data)
  }

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "kratos_drive/totalvehicle", body: { filterdata: gloablfilter } }, appyDataVehicle)
    fetchData({ url: API_URL_MAIN + "kratos_drive/topkpisfirstpage", body: { filterdata: gloablfilter } }, appyData)
    fetchData({ url: API_URL_MAIN + "kratos_drive/totalcount_drive_bus", body: { filterdata: gloablfilter } }, appyTotalData)
  }, [gloablfilter])

  const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheettml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const excelFileName = "DriveTotalVehicle";

  const exportToExcel = async () => {

    const flatData = totalvehicledata.map(item => ({
      'Vin': item.key.vehicleId,
      'Regis No.': item.key.regNumber,
      'City': item.key.City,
      'Depot': item.key.Depot_Name,
      'Date': new Date(item.last_signal_on.value_as_string).toISOString().split('T')[0]
      // 'Date': new Date(item.last_signal_on.value_as_string).toLocaleDateString()
  }));

      const ws = XLSX.utils.json_to_sheet(flatData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, excelFileName + fileExtension);

      // fetchData({ url: API_URL_MAIN + "auth/logging", body: { page_name: "Action_data_off_down" } }, [])

  }

  const loggedInUser = useSelector(selectLoggedInUser);
  return (
    <>
    {(totalvehicledata.length > 0) &&
     <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="row">
                <h5>Vehicle Details</h5>
              </div>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">

              <div className="tablecontainer" style={{ overflowX: "scroll", minHeight: "300px" }}>
                <table className="table table-striped" style={{ width: "100%" }}>
                  <thead style={{ backgroundColor: '#83A4CF', color: '#fff', position: "sticky", top: 0, zIndex: 0 }}>
                    <tr>
                      <th scope="col">Vin</th>
                      <th scope="col">Reg. No.</th>
                      <th scope="col">City</th>
                      <th scope="col">Deopt</th>
                      <th scope="col">Last_data_received_date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {totalvehicledata.map((item, index) => (
                      <tr key={index}>
                        <td>{item.key.vehicleId}</td>
                        <td>{item.key.regNumber}</td>
                        <td>{item.key.City}</td>
                        <td>{item.key.Depot_Name}</td>
                        <td>{new Date(item.last_signal_on.value_as_string).toISOString().split('T')[0]}</td>
                        {/* <td>{new Date(item.last_signal_on.value_as_string).toLocaleDateString()}</td> */}
                      </tr>
                    ))}
                  </tbody>

                </table>
              </div>
            </div>

            <div className="modal-footer">
              <div className='row'>
                <div className='col-md-10 text-start'>
                  <span className='' style={{color:"red", fontSize:"12px", fontWeight:"bolder"}}>Note : </span>
                  <span className='' style={{fontSize:"13px"}}>Please take a note, Here we are showing all the vehicles whose data we have received atleast once.</span>
                  {/* <span style={{fontSize:"13px"}}>Note: Please take a note, Here we are showing all the vehicles whose data we have received atleast once. </span> */}
                </div>
                <div className='col-md-2'>
                  <button type="button" className="btn1 btn_drive" onClick={exportToExcel} style={{backgroundColor:"#83A4CF", color:"#fff", borderRadius:"4px", boxShadow:"#83A4CF"}}>Download</button>
                </div>
              </div>

              {/* <span>Note: Please take a note, Here we are showing all the vehicles whose data we have received atleast once. </span>
              <button type="button" class="btn" onClick={exportToExcel} style={{backgroundColor:"#83A4CF", color:"#fff"}}>Download</button> */}
            </div>
          </div>
        </div>
    </div>
    }

      <section className="kpi my-3">
        <div className="row">
          <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-md-4 col-lg-2 col-sm-4 col-6 pl-0 kratos_tkps' : 'col-md-4 col-lg-3 col-sm-4 col-6 pl-0 kratos_tkps')}>
          {
          // loggedInUser.flagForHideShow === "ERC" &&
          (loggedInUser.flagForHideShow === "FLEETEV" && isCESL_lastDate) ? 
            <div className="widget_kratos widget_Kratos p-2 py-3 d-flex align-items-center" data-bs-toggle="modal" data-bs-target="#staticBackdrop" style={{ marginLeft: 0, cursor:"pointer" }}>
              <div className="widgetIcon">
                <img src="../../../assets/img_Bus/EV-Logo_iconB.png" /> 
              </div>
              <div className="ps-2 txtColor">
                <p className="h5 m-0 font-kratos-head_a">{totalvehicle}|{topdata.vehiclecount}</p>
                <p className="m-0"><small>Total<b>|</b>Driven Vehicle</small></p>
              </div>
            </div>

            :
            <div className="widget_kratos widget_Kratos p-2 py-3 d-flex align-items-center" style={{ marginLeft: 0}}>
            <div className="widgetIcon">
              <img src="../../../assets/img_Bus/EV-Logo_iconB.png" /> 
            </div>
            <div className="ps-2 txtColor">
              <p className="h5 m-0 font-kratos-head_a">{totalvehicle}|{topdata.vehiclecount}</p>
              <p className="m-0"><small>Total<b>|</b>Driven Vehicle</small></p>
            </div>
          </div>
          }
          </div>
          <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-md-4 col-lg-2 col-sm-4 col-6 pl-0 kratos_tkps' : 'col-md-4 col-lg-3 col-sm-4 col-6 pl-0 kratos_tkps')}>
            <div className="widget_kratos widget_Kratos p-2 py-3 d-flex align-items-center" style={{ marginLeft: 0 }}>
              <div className="widgetIcon">
                <img src="../../../assets/img_Bus/charging_iconB.png" /> </div>
              <div className="ps-2 txtColor">
                <p className="h5 m-0 font-kratos-head">{topdata.total_km} km</p>
                <p className="m-0"><small>Total km travelled</small></p>
              </div>
            </div>
          </div>
          <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-md-4 col-lg-2 col-sm-4 col-6 pl-0 kratos_tkps' : 'col-md-4 col-lg-3 col-sm-4 col-6 pl-0 kratos_tkps')}>
            <div className="widget_kratos widget_Kratos p-2 py-3 d-flex align-items-center" style={{ marginLeft: 0 }}>
              <div className="widgetIcon">
                <img src="../../../assets/img_Bus/electric-station (1).png" /> </div>
              <div className="ps-2 txtColor">
                <p className="h5 m-0 font-kratos-head">{topdata.median_range} km</p>
                <p className="m-0"><small>Median Range (for 100% discharge)</small></p>
              </div>
            </div>
          </div>
          <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-md-4 col-lg-2 col-sm-4 col-6 pl-0 kratos_tkps' : 'col-md-4 col-lg-3 col-sm-4 col-6 pl-0 kratos_tkps')}>
            <div className="widget_kratos widget_Kratos p-2 py-3 d-flex align-items-center" style={{ marginLeft: 0 }}>
              <div className="widgetIcon">
                <img src="../../../assets/img_Bus/electric_iconB.png" /> </div>
              <div className="ps-2 txtColor">
                <p className="h5 m-0 font-kratos-head">{topdata.mean_whr_km}</p>
                <p className="m-0"><small>Median kWh/km</small></p>
              </div>
            </div>
          </div>
          {loggedInUser.flagForHideShow === "ERC" &&
            <div className="col-md-4 col-lg-2 col-sm-4 col-6 pl-0 kratos_tkps">
              <div className="widget_kratos widget_Kratos p-2 py-3 d-flex align-items-center" style={{ marginLeft: 0 }}>
                <div className="widgetIcon">
                  <img src="../../../assets/img_Bus/electric-bus (2).png" /> </div>
                <div className="ps-2 txtColor">
                  <p className="h5 m-0 font-kratos-head">{topdata.Median_NetkWh} Kwh</p>
                  <p className="m-0"><small>Median Net Consumption/cycle</small></p>
                </div>
              </div>
            </div>
          }
          {
            loggedInUser.flagForHideShow === "ERC" &&
            <div className="col-md-4 col-lg-2 col-sm-4 col-6 pl-0 kratos_tkps">
              <div className="widget_kratos widget_Kratos p-2 py-3 d-flex align-items-center" style={{ marginLeft: 0 }}>
                <div className="widgetIcon">
                  <img src="../../../assets/img_Bus/battery-charge_iconB.png" /> </div>
                <div className="ps-0 txtColor">
                  <p className="h5 m-0 font-kratos-head">{topdata.median_dis_duration}%</p>
                  <p className="m-0"><small>Avg Discharge/Cycle</small></p>
                </div>
              </div>
            </div>
          }
        </div>
      </section>
    </>
  )
}